import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {AddOutlined, DeleteOutlined, EditOutlined} from '@material-ui/icons';
import PageWrapper from '../../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../../shared/pagetitle/PageTitle.js';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import BlockUI from '../../../shared/blockui/BlockUI.tsx';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import {criarColunaOpcoes} from '../../components/ColunaOpcoes.jsx';
import DialogDocumento from '../../dialogs/cadastro/DialogDocumento.jsx';
import useCadastroBasico from '../../components/cadastro/useCadastroBasico.js';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import PageNaoEncontrada from '../../../PageNaoEncontrada.jsx';
import useCheckModule from '../../../../hooks/useCheckModule.js';
import {MODULOS_CADASTROS, URL_DOCUMENTOS_CADASTRO} from '../../../../constants/index.js';
import {buttonTableCell, containerPaper} from '../../../../utils/styles.js';
import {PAGINACAO_PADRAO, textoSemRegistros} from '../../components/paginacao.js';

const FILTER_OPTIONS = {filterByColumn: true};
const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    ...containerPaper(theme),
    colunaOrdem: {
        width: '100px'
    },
    ...buttonTableCell(theme)
}));

/*
 * Cadastro de Documentos (ordem, nome e descrição em HTML): lista com filtro e
 * paginação, e criação/edição em diálogo. Não tem módulo próprio: libera para
 * quem tem qualquer módulo de cadastro (como o submenu Cadastro do PrimeFaces).
 */
export default function PageDocumentos() {
    const classes = useStyles();
    const checkModule = useCheckModule();
    const podeAcessar = MODULOS_CADASTROS.some(modulo => checkModule(modulo));
    const {
        itens,
        carregando,
        salvando,
        dialogAberto,
        fecharDialog,
        itemEmEdicao,
        adicionar,
        editar,
        salvar,
        excluir
    } = useCadastroBasico({url: URL_DOCUMENTOS_CADASTRO, nomeItem: 'Documento', habilitado: podeAcessar});

    if (!podeAcessar) {
        return <PageNaoEncontrada/>;
    }

    return (
        <PageWrapper>
            <PageTitle title='Documento'/>
            <Paper className={classes.containerPaper}>
                <BlockUI loading={carregando}>
                    <DataGrid
                        rows={itens}
                        comparatorKeys={['id']}
                        filterOptions={FILTER_OPTIONS}
                        paginate
                        paginateOptions={PAGINACAO_PADRAO}
                        tableContainerProps={TABLE_CONTAINER_PROPS}
                        noRecordsText={textoSemRegistros(carregando)}
                        toolbarContent={(
                            <ContainedButton startIcon={<AddOutlined/>} onClick={adicionar}>
                                Adicionar
                            </ContainedButton>
                        )}
                        columns={[
                            {label: 'Ordem', field: 'ordem', filterable: true, className: classes.colunaOrdem, valueGetter: valor => ouTraco(valor)},
                            {label: 'Nome', field: 'nome', filterable: true, valueGetter: valor => ouTraco(valor)},
                            criarColunaOpcoes(row => [
                                {titulo: 'Editar', icone: <EditOutlined/>, onClick: () => editar(row)},
                                {titulo: 'Excluir', icone: <DeleteOutlined/>, onClick: () => excluir(row)}
                            ], {className: classes.buttonTableCell})
                        ]}/>
                </BlockUI>
            </Paper>
            <DialogDocumento
                open={dialogAberto}
                onClose={fecharDialog}
                item={itemEmEdicao}
                salvando={salvando}
                onSalvar={salvar}/>
        </PageWrapper>
    );
}
